import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'

export type FetchProductSizesForOptionsAction = FSA<undefined, SelectOption[], string>
type FetchProductSizesForOptions = (searchText?: string) => MrxThunk<FetchProductSizesForOptionsAction>
type QueryResponse = GraphQLResponse<'productSizesForOptions', SelectOption[]>

const FETCH_PRODUCT_SIZES_FOR_OPTIONS = `
  query fetchProductSizesForOptions($filters: ProductSizesFilters!) {
    productSizesForOptions(filters: $filters) {
      id
      name
    }
  }
`

const fetchProductSizesForOptions: FetchProductSizesForOptions = searchText => async (dispatch, getState) => {
  dispatch({
    type: t.FETCH_PRODUCT_SIZES_FOR_OPTIONS,
    meta: { done: false }
  })

  try {
    const workspaceId = getState()?.workspaces?.activeWorkspace?.id
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_PRODUCT_SIZES_FOR_OPTIONS,
      variables: { filters: { workspaceId, searchText } }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { productSizesForOptions } = data
    if (!productSizesForOptions) {
      throw new Error("Can't get product sizes!")
    }

    dispatch({
      type: t.FETCH_PRODUCT_SIZES_FOR_OPTIONS,
      payload: productSizesForOptions,
      meta: { done: true }
    })
  } catch (err) {
    dispatch({
      type: t.FETCH_PRODUCT_SIZES_FOR_OPTIONS,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchProductSizesForOptions }
